import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useLocation } from "react-router-dom";
import Feature from "../../components/Feature/Feature";
import "./Video.scss";
import Laurels from "../../components/Laurels/Laurels";
import firebase from "../../config/firebase";
import reel from "../../assets/reel.png";

const defaultVideoDetails = {
  url: "",
  description: "",
  isFeature: false,
};

function VideoGallery() {
  const location = useLocation();

  let [videoDetails, setVideoDetails] = useState(defaultVideoDetails);
  const [isReel, setIsReel] = useState(false);

  const getVideos = async () => {
    const db = firebase.firestore();
    const page = location.pathname.replace("/", "");
    console.log(page);
    try {
      const querySnapshot = await db.collection(page).get();
      for (const doc of querySnapshot.docs) {
        const data = doc.data();
        setVideoDetails(data);
        console.log(data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const page = location.pathname.replace("/", "");
    if (page === "reel") {
      setIsReel(true);
      getVideos();
    } else {
      let { item } = location.state;
      setVideoDetails(item);
    }
  }, [location.pathname]);

  function newlineText(text) {
    const newText = text.split("&&").map((str, i) => (
      <p key={i} className={`${i === 0 && "fakey ital"} fakey`}>
        {str}
      </p>
    ));

    return newText;
  }

  const musicVideoCredits = () => (
    <div>
      <p className="flex flex-row fakey ital">artist. <span className="pl-1 font-bold not-italic fakey">{videoDetails.artist}</span></p>
      <p className="flex flex-row fakey ital ml-1">dir. <p className="pl-1 not-italic font-bold fakey">{videoDetails.director}</p></p>
      <p className="fakey">{videoDetails.year}</p>
    </div>
  )

  return (
    <div className="videoPageContainer">
      <div className="center">
        {isReel ? (
          <video id="reelVideo" controls poster={reel}>
            <source
              src="https://firebasestorage.googleapis.com/v0/b/jocelyns-portfolio.appspot.com/o/reel%2F2025%20DP%20Reel%20COMPRESSED.mp4?alt=media"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        ) : videoDetails.url ? (
          <Video url={videoDetails.url} />
        ) : null}
      </div>

      {videoDetails.name && <Feature name={videoDetails.name} />}
      <div className="videoDescription">
        {videoDetails.isMusicVideo ? (
          musicVideoCredits()
        )
        : 
        newlineText(videoDetails.description)
        }
      </div>
      {videoDetails.hasLaurels && <Laurels name={videoDetails.name} />}
    </div>
  );
}

const Video = ({ url }) => {
  return (
    <div className="player-wrapper">
      <ReactPlayer
        width="100%"
        height="100%"
        controls={true}
        className="react-player"
        url={url}
      />
    </div>
  );
};

export default VideoGallery;
